import { TreeItem, TreeView } from '@mui/lab';
import {
  Box,
  Card, CardContent, CardHeader, CircularProgress, Grid, Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { getActivitiesByUnitId } from '../../../../activities/actions/activitiesActions';
import { IUnit } from '../interfaces';
import UnitMenu from './UnitMenu';
import TreeActivity from './TreeList/TreeActivity';
import { IActivity } from '../../../../activities/interfaces';
import { ReactComponent as Pen } from '../../../../../assets/svg/thatBook/pen.svg';

interface IAdminActivityItemProps{
  unit: IUnit;
}

const AdminActivityItem = ({ unit }: IAdminActivityItemProps ) => {
  const { activitiesList, loadingGetActivity } = useAppSelector(( state ) => state.activity );
  const dispatch = useAppDispatch();
  const [expandedActivities, setExpandedActivities] = useState<string[]>([]);
  const handleToggleActivities = ( event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpandedActivities( nodeIds );
  };
  useEffect(() => {
    dispatch( getActivitiesByUnitId( unit.id ));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Card sx={{ height: 322 }}>
        <CardHeader
          action={(
            <UnitMenu id={unit.id} />
          )}
          title={(
            <Typography fontSize={20} fontWeight="bold" color={grey[900]} noWrap maxWidth={310}>
              {unit.name}
            </Typography>
          )}
          subheader={(
            <Typography fontSize={14} variant="body2" height={40}>
              {unit.description}
            </Typography>
          )}
        />
        <CardContent>
          <TreeView
            aria-label="customized"
            defaultCollapseIcon={<Pen fill="#707070" width={20} height={20} />}
            defaultEndIcon={<Pen fill="#707070" width={20} height={20} />}
            defaultExpandIcon={
              <Pen fill="#707070" width={20} height={20} />
            }
            sx={{
              flexGrow: 1, maxWidth: 400, overflowY: 'auto',
            }}
            expanded={expandedActivities}
            onNodeToggle={handleToggleActivities}
          >
            <TreeItem
              nodeId={`${unit.id}2`}
              label={
                (
                  <Box display="flex">
                    <Typography>
                      Temas
                    </Typography>
                    <Typography ml={5}>
                      (
                      {activitiesList.filter(( item: IActivity ) => item.unitId === unit.id ).length}
                      )
                    </Typography>
                  </Box>
                )
              }
              sx={{ height: expandedActivities.includes( `${unit.id}2` ) ? 100 : 'auto' }}
            >
              {loadingGetActivity ? ( <Box textAlign="center"><CircularProgress size={20} /></Box> ) : (
                <>
                  {activitiesList && activitiesList.length > 0 ? activitiesList.map(( activity: IActivity, indexActivity: number ) => activity.unitId === unit.id
                  && (
                    <TreeActivity activity={activity} numberActivity={indexActivity} key={indexActivity.toString()} />
                  )) : 'Sin Temas'}
                </>
              )}
            </TreeItem>
          </TreeView>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default AdminActivityItem;
